/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.6",
    versionName: "0.6.0-nightly.2026.8.6",
    versionChannel: "nightly",
    buildDate: "2026-08-06T00:26:33.339Z",
    commitHash: "18b0d1cac090e2cb3f04af3e3b0be76365a2c5a0",
};
